import { render, staticRenderFns } from "./Library.vue?vue&type=template&id=164ed480"
import script from "./Library.vue?vue&type=script&lang=js"
export * from "./Library.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports